module.exports = __webpack_public_path__ + "static/media/smile5.110b6328.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/smileImg/smile5.png
// module id = 78
// module chunks = 0